<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock
        title="Organisation de l'équipe officinale : formation continue"
      >
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="11">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; DPC du (des) pharmacien(s) adjoint(s) ?
              </span>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  v-if="dossier.nbAdjoints > 0 || dossier.nbAdjoints == null"
                >
                  <v-radio-group
                    v-model="dossier.adjointsDPC"
                    row
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="adjointsDPC"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="adjointsDPC"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col v-else>
                  <i
                    >vous avez déclaré l'absence de pharmacien adjoint dans
                    votre établissement (partie Organisation de l'équipe
                    officinale > Composition)</i
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="dossier.adjointsDPC">
            <v-col cols="12" md="8">
              <v-textarea
                v-model="dossier.adjointsDPCFormations"
                label="Si oui, précisez l’intitulé de la ou des formation(s) DPC au cours des 5 dernières années (joindre les justificatifs) :"
                counter="300"
                rows="3"
                :rules="textareaRules"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="11">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; DPC et formations du(des) préparateur(s) en pharmacie ?
              </span>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  v-if="
                    dossier.nbPreparateurs > 0 || dossier.nbPreparateurs == null
                  "
                >
                  <v-radio-group
                    v-model="dossier.preparateursDPC"
                    row
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="preparateursDPC"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="preparateursDPC"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col v-else>
                  <i
                    >vous avez déclaré l'absence de préparateur dans votre
                    établissement (partie Organisation de l'équipe officinale >
                    Composition)</i
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="dossier.preparateursDPC">
            <v-col cols="12" md="8">
              <v-textarea
                v-model="dossier.preparateursDPCFormations"
                label="Si oui, précisez l’intitulé de la ou des formation(s) DPC au cours des 5 dernières années (joindre les justificatifs) :"
                counter="300"
                rows="3"
                :rules="textareaRules"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="11">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; Abonnement à des journaux pharmaceutiques, médicaux ?
              </span>
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio-group
                    v-model="dossier.journauxAbonnement"
                    row
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="journauxAbonnement"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="journauxAbonnement"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="dossier.journauxAbonnement">
            <v-col cols="12" md="8">
              <v-textarea
                v-model="dossier.journauxAbonnementListe"
                label="Si oui, lesquels ?"
                counter="300"
                rows="3"
                :rules="textareaRules"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "PartieX",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    textareaRules: [
      v => (v !== null && v.length <= 300) || "300 caractère max."
    ]
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (!this.dossier.adjointsDPC)
          this.dossier.adjointsDPCFormations = null;
        if (!this.dossier.preparateursDPC)
          this.dossier.preparateursDPCFormations = null;
        if (!this.dossier.journauxAbonnement)
          this.dossier.journauxAbonnementListe = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
